import React, { useMemo } from 'react';
import _ from 'underscore';

import { getFirstIncompleteLevel } from 'functions/getCourseExerciseInformation';
import { courseExerciseStatus } from 'constants/tests';
import { HeadingLabel, SyllabusName, ModuleName, IconContainer, NameAndModuleContainer } from './styles';

export default function CourseSyllabus({ user, course, language, handleClickOnLevelName }) {
  const incompleteLevel = useMemo(() => getFirstIncompleteLevel(course, language), [course, language]);

  const getIconOfModule = (isCompletedInAnyLanguage, levelNames, isCurrent) => {
    let isCompleted =
      language === 'any' && isCompletedInAnyLanguage
        ? true
        : _.every(_.pluck(levelNames, 'isCompleted'), (levelCompleted) => levelCompleted === true);

    let icon = `${isCompleted ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'}`;
    if (isCurrent) icon = `fa-solid fa-circle-arrow-right`;

    let status = '';
    if (isCompleted) status = 'completed';
    if (isCurrent) status = 'current';
    return [icon, status];
  };

  const getIconOfSyllabus = (syllabus, isCurrent) => {
    const modules = syllabus.modules;
    let isCompleted = _.every(modules, (module) => {
      if (language === 'any') return module.exercise.isCompletedInAnyLanguage;
      const levelCompleted = module.exercise.languagesCompleted[language];
      return _.every(levelCompleted, (level) => level.isCompleted);
    });

    let icon = `${isCompleted ? 'fa-solid fa-circle-check' : 'fa-regular fa-circle'} fa-lg`;
    if (course.isPaidCourse) {
      let hasPaidExercise = _.some(syllabus.modules, (module) => module.accessLevel === 'paid');
      if (hasPaidExercise) icon = `fa fa-lock`;
      let hasSignedInAccessLevel = _.some(syllabus.modules, (module) => module.accessLevel === 'signedIn');
      if (user?._id && hasSignedInAccessLevel) icon = 'fa-regular fa-circle fa-lg';
    }
    if (isCurrent) icon = `fa-solid fa-circle-arrow-right fa-lg`;

    let status = '';
    if (isCompleted) status = courseExerciseStatus.COMPLETED;
    if (isCurrent) status = courseExerciseStatus.CURRENT;
    return [icon, status];
  };

  return (
    <>
      <HeadingLabel>Syllabus</HeadingLabel>
      {course.syllabus.map((syllabus, index) => {
        return (
          <NameAndModuleContainer key={syllabus.name}>
            <SyllabusName
              isCurrent={incompleteLevel.syllabusIndex === index}
              onClick={(event) =>
                handleClickOnLevelName(
                  event,
                  course?.syllabus?.[index]?.modules?.[0]?.exercise?.id,
                  0,
                  course?.syllabus?.[index]?.modules?.[0]?.exercise?.testImpl,
                  course?.syllabus?.[index]?.modules?.[0]?.exercise?.inputExercise,
                  course?.syllabus?.[index]?.modules?.[0]?.accessLevel
                )
              }
            >
              <IconContainer status={getIconOfSyllabus(syllabus, incompleteLevel.syllabusIndex === index)[1]}>
                <i className={getIconOfSyllabus(syllabus, incompleteLevel.syllabusIndex === index)[0]} />
              </IconContainer>
              {syllabus.name}
            </SyllabusName>
            {syllabus.modules.map((module, i) => (
              <ModuleName
                key={module.name}
                isCurrent={incompleteLevel.syllabusIndex === index && incompleteLevel.moduleIndex === i}
                onClick={(event) =>
                  handleClickOnLevelName(
                    event,
                    module.exercise.id,
                    0,
                    module.exercise.testImpl,
                    module.exercise.inputExercise,
                    module.accessLevel
                  )
                }
              >
                <IconContainer
                  status={
                    getIconOfModule(
                      module.exercise.isCompletedInAnyLanguage,
                      module.exercise.languagesCompleted[language === 'any' ? 'python' : language],
                      incompleteLevel.syllabusIndex === index && incompleteLevel.moduleIndex === i
                    )[1]
                  }
                >
                  <i
                    className={
                      getIconOfModule(
                        module.exercise.isCompletedInAnyLanguage,
                        module.exercise.languagesCompleted[language === 'any' ? 'python' : language],
                        incompleteLevel.syllabusIndex === index && incompleteLevel.moduleIndex === i
                      )[0]
                    }
                  />
                </IconContainer>
                {module.name}
              </ModuleName>
            ))}
          </NameAndModuleContainer>
        );
      })}
    </>
  );
}
